import { render, staticRenderFns } from "./DelButton.vue?vue&type=template&id=bfe6af8e&"
import script from "./DelButton.vue?vue&type=script&lang=js&"
export * from "./DelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports